import { apiFetch } from "./auth";

export interface HealthPing {
  status: "ok" | "degraded";
  service: string;
  version: string;
  time: string;
}

export interface HealthCheck {
  ok: boolean;
  latencyMs: number | null;
  detail?: string;
}

export interface HealthDeep {
  status: "ok" | "degraded";
  service: string;
  checks: {
    database: HealthCheck;
    keycloak: HealthCheck;
    /** Sempre presente (SPEC-20260507-0130 — Redis é dep crítica do BullMQ saga queue). */
    redis: HealthCheck;
    /** Presente apenas quando WOS depende do IDP (WynkAuth ON ou IDP_USE_HTTP=true). */
    idp?: HealthCheck;
  };
  uptimeMs: number;
}

interface ApiSuccess<T> { success: true; data: T }

export async function getHealth(): Promise<HealthPing> {
  const r = await apiFetch<ApiSuccess<HealthPing>>("/api/health");
  return r.data;
}

export async function getHealthDeep(): Promise<HealthDeep> {
  const r = await apiFetch<ApiSuccess<HealthDeep>>("/api/health/deep");
  return r.data;
}
